import React from 'react';
import { normalizeUrl } from './normalize-url.js';
import { useI18n } from '../i18n/index.jsx';

/**
 * "Sponsored by" section for a session card. Renders nothing when there are no
 * sponsors. Each sponsor is a clickable tile (logo, or the name when no logo),
 * opening the sponsor website in a new tab. Styled via shared/sponsored-by.css,
 * which is @import-ed into each widget's stylesheet (Shadow DOM inlining).
 *
 * @param {{ sponsors: import('../types/async-data').SponsorRef[] }} props
 */
export default function SponsoredBy({ sponsors }) {
  const { t } = useI18n();
  if (!sponsors || sponsors.length === 0) return null;

  return (
    <div className="sponsored-by">
      <h4 className="sponsored-by__label">{t('sponsored_by')}</h4>
      <div className="sponsored-by__list">
        {sponsors.map(sponsor => {
          const href = normalizeUrl(sponsor.website);
          const content = sponsor.logo_url ? (
            <img
              className="sponsored-by__logo"
              src={sponsor.logo_url}
              alt={sponsor.name || 'Sponsor'}
              height={60}
              loading="lazy"
            />
          ) : (
            <span className="sponsored-by__name">{sponsor.name}</span>
          );

          return href ? (
            <a
              key={sponsor.id}
              className="sponsored-by__tile"
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={sponsor.name ? t('visit_sponsor', { name: sponsor.name }) : t('visit_sponsor_generic')}
            >
              {content}
            </a>
          ) : (
            <div key={sponsor.id} className="sponsored-by__tile">
              {content}
            </div>
          );
        })}
      </div>
    </div>
  );
}
